import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const EditIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 17 17"
    fill="none"
    {...props}
  >
    <Path d="M14.1677 6.41642L5.52738 15.0568C5.43509 15.149 5.32047 15.2159 5.19469 15.2507L1.71567 16.2148C1.14928 16.3717 0.628254 15.8507 0.785206 15.2843L1.74927 11.8053C1.78413 11.6795 1.85095 11.5649 1.94325 11.4726L10.5836 2.83229M14.1677 6.41642L16.0225 4.56159C16.3178 4.26634 16.3178 3.78765 16.0225 3.49241L13.5076 0.977455C13.2123 0.682207 12.7337 0.682208 12.4384 0.977455L10.5836 2.83229M14.1677 6.41642L10.5836 2.83229" stroke={color} strokeWidth="1.5" />
  </Svg>
);

EditIcon.displayName = 'EditIcon';
